var _defs, _circle, _path, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSensors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sensorJrPanel",
    "data-name": "Sensor Jr Panel",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Sensors-cls-1{fill:#14163d;}.Sensors-cls-2{fill:#00658a;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Sensors-cls-1",
    cx: 76.5,
    cy: 76.5,
    r: 76.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Sensors-cls-2",
    d: "M189.6,157.61V236A76.51,76.51,0,0,1,120,191.26Z",
    transform: "translate(-113.1 -83)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "Sensors-cls-2",
    cx: 76.5,
    cy: 74.87,
    r: 9.77
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "Sensors-cls-2",
    cx: 22.79,
    cy: 60.22,
    r: 8.14
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "Sensors-cls-2",
    cx: 118.82,
    cy: 105.8,
    r: 8.14
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "Sensors-cls-2",
    cx: 126.96,
    cy: 61.85,
    r: 8.14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensors);
export default __webpack_public_path__ + "static/media/Sensors.1c341a07e0caa6168cf12e8d834ccc51.svg";
export { ForwardRef as ReactComponent };